import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import Additemmodal from "./additemmodal";
import Itemlist from "./itemlist";
import searchaction from "../../context/action/item/searchaction";

const Item = () => {
  const {initDispatch}=useContext(GlobalContext);

  const [show, setshow] = useState(false);

  return (
    <div className="min-h-screen bg-slate-50 p-6 md:p-8">
      <Additemmodal show={show} setshow={setshow} />
      
      {/* Page Header */}
      <div className="flex items-center justify-between mb-8">
        <div>
          <h1 className="text-2xl font-bold text-slate-800">کاڵا</h1>
          <p className="text-sm text-slate-400 mt-0.5">ناساندنی کاڵای نوێ</p>
        </div>
      </div>

      {/* Button Container */}
      <div className="w-full mx-auto mb-6 sm:mb-8">
        <div className="flex justify-start">
          <button
            className="w-full sm:w-auto h-12 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150"
            onClick={() => {
              setshow(true);
            }}
          >
            زیادکردن
          </button>
        </div>
      </div>
      
      <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto">
            
        {/* Section Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
          <h2 className="text-base font-semibold text-slate-800">لیستی کاڵا</h2>
        </div>

        {/* Search Bar */}
        <div className="px-6 py-4 border-b border-slate-50">
          <div className="relative">
            <input
              className="w-full h-10 pr-10 pl-4 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 bg-slate-50"
              placeholder="گەڕان بە ناو - کۆدی کاڵا"
              onChange={(val) => {
                searchaction(val.target.value)(initDispatch)
            }}
            />
          </div>
        </div>
      
        <Itemlist />
      </div>
    </div>
  );
};

export default Item;
